import { useEffect, useState } from 'react';

import ItemTypeIcon from 'components/common/item-type-icon';
import { classnames } from 'lib/classnames';
import { dataFormat } from 'lib/fields';
import useI18n from 'lib/hooks/useI18n';
import { ItemType } from 'lib/models';
import { FieldValue } from 'lib/types/field';

import Status from './Status';

import styles from './index.module.less';

const cx = classnames(styles);
interface ChangeDataProps {
  title?: string;
  data: FieldValue;
}

const ChangeView: React.FC<ChangeDataProps> = ({ data, title }) => {
  const { t } = useI18n();
  const [itemTypeIcon, setItemTypeIcon] = useState('');
  useEffect(() => {
    const fetchItemType = async id => {
      if (!id || itemTypeIcon) return;
      const itemType = await new Parse.Query(ItemType).equalTo('objectId', id).select('icon').first();
      setItemTypeIcon(itemType?.get('icon'));
    };
    const node = data.find(item => item.type === 'itemType');
    if (node) {
      fetchItemType(node.after.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.length]);

  return (
    <div className={cx('view-wrap')}>
      {title && <div className={cx('title')}>{title}</div>}
      <div className={cx('view-header')}>
        <span>{t('pages.itemMove.fieldName')}</span>
        <span>{t('pages.itemMove.current.field')}</span>
        <span>{t('pages.itemMove.next.field')}</span>
      </div>
      <div className={cx('view-content')}>
        {data.map(item => {
          if (item.type === 'itemType') {
            return (
              <div className={cx('view-item')} key={`${item.name}-${item.type}`}>
                <span className={cx('column-text')}>{item.name}</span>
                <span className={cx('column-text')}>
                  <ItemTypeIcon name={item.before.data} icon={item.before.icon} className={cx('item-type-icon')} />
                  {item.before.data}
                </span>
                <span className={cx('column-text')}>
                  <ItemTypeIcon name={item.after.data} icon={itemTypeIcon} className={cx('item-type-icon')} />
                  {item.after.data}
                </span>
              </div>
            );
          }
          if (item.type === 'status') {
            return (
              <div className={cx('view-item')} key={`${item.name}-${item.type}`}>
                <span className={cx('column-text')}>{item.name}</span>
                <span className={cx('column-text')}>
                  <Status name={item.before.name} type={item.before.type} />
                </span>
                <span className={cx('column-text')}>
                  <Status name={item.after.name} type={item.after.type} />
                </span>
              </div>
            );
          }

          return (
            <div key={item.name} className={cx('view-item')}>
              <span className={cx('column-text')}>{item.name}</span>
              <span className={cx('column-text')}>{dataFormat(item.before)}</span>
              <span className={cx('column-text')}>{dataFormat(item.after)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChangeView;
